import { getCloseButtonStyles } from './AlertCDS.styles';

export const getAlertSlotProps = ({ onClose, variant }) => ({
  closeButton: {
    onClose,
    sx: getCloseButtonStyles({ variant }),
  },
});

export const toastOptions = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  autoHideDuration: 12000,
};
